import { render, staticRenderFns } from "./EmployeeFileDetail.vue?vue&type=template&id=51e7513f&scoped=true&lang=pug"
import script from "./EmployeeFileDetail.vue?vue&type=script&lang=js"
export * from "./EmployeeFileDetail.vue?vue&type=script&lang=js"
import style0 from "./EmployeeFileDetail.vue?vue&type=style&index=0&id=51e7513f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e7513f",
  null
  
)

export default component.exports